import { useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

export function ApprovalActionModal({
  open,
  onOpenChange,
  mode = "approve",
  count = 1,
  isSubmitting,
  onSubmit,
}) {
  const [reason, setReason] = useState("");
  const [comment, setComment] = useState("");
  const [wasOpen, setWasOpen] = useState(open);
  const isReject = mode === "reject";

  // Adjusting state during render is React's documented way to reset a form when
  // a prop changes — an effect for this renders the stale values once first.
  if (open !== wasOpen) {
    setWasOpen(open);
    if (open) {
      setReason("");
      setComment("");
    }
  }

  const submit = (event) => {
    event.preventDefault();
    onSubmit({ reason, comment });
  };

  const title = isReject
    ? count > 1
      ? `Reject ${count} invoices`
      : "Reject invoice"
    : count > 1
      ? `Approve ${count} invoices`
      : "Approve invoice";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false} className="max-w-md">
        <form onSubmit={submit}>
          <DialogHeader>
            <DialogTitle>{title}</DialogTitle>
            <DialogDescription>
              {isReject
                ? "Provide a reason and notes. Rejected invoices return to the supplier queue."
                : "Add an optional note for the approval record."}
            </DialogDescription>
          </DialogHeader>

          <DialogBody className="space-y-4">
            {isReject && (
              <div className="invoice-detail-field">
                <label htmlFor="approval-reason" className="invoice-detail-label">
                  Reason
                </label>
                <Input
                  id="approval-reason"
                  required
                  value={reason}
                  onChange={(event) => setReason(event.target.value)}
                  className="h-10 rounded-[0.8rem] border-line bg-background shadow-none"
                />
              </div>
            )}
            <div className="invoice-detail-field">
              <label htmlFor="approval-comment" className="invoice-detail-label">
                Comments{isReject ? "" : " (optional)"}
              </label>
              <textarea
                id="approval-comment"
                required={isReject}
                rows={4}
                value={comment}
                onChange={(event) => setComment(event.target.value)}
                className="invoice-detail-textarea"
              />
            </div>
          </DialogBody>

          <DialogFooter>
            <Button
              type="button"
              variant="outline"
              className="h-9 rounded-[0.8rem] border-line shadow-none sm:min-w-24"
              onClick={() => onOpenChange(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant={isReject ? "destructive" : "default"}
              className="h-9 rounded-[0.8rem] sm:min-w-24"
              disabled={isSubmitting}
            >
              {isReject ? "Reject" : "Approve"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
